export const dramas = [
  {
    id: 'tv-001',
    title: '善良的女秘书',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20workplace%20drama%20poster%20featuring%20a%20kind%20professional%20female%20secretary%20in%20a%20warm%20deep%20red%20office%2C%20soft%20natural%20window%20light%2C%20minimal%20calm%20background%2C%20editorial%20cinematic%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-001&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '职场', '爱情'],
    actors: ['林知夏', '沈砚清', '周慕白', '苏念安'],
    director: '陆为安',
    episodes: 36,
    updateTime: '2025-10-12',
    synopsis:
      '讲述了初入职场却始终保有善意的女秘书林知夏，在风云变幻的集团总部中，凭借真诚与专业化解一次次危机，并逐渐揭开一段尘封往事的故事。她在权谋与温情之间，守住初心，也收获了成长与爱情。',
    tags: ['暖心治愈', '职场成长', '都市情感'],
    rating: 8.9,
    heat: 9820,
  },
  {
    id: 'tv-002',
    title: '都市晨光',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20city%20drama%20poster%20showing%20skyline%20at%20sunrise%20with%20deep%20red%20accents%20and%20a%20lone%20figure%2C%20soft%20morning%20haze%2C%20clean%20minimal%20background%2C%20editorial%20cinematic%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-002&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['都市', '剧情', '励志'],
    actors: ['陈屿', '许晚舟', '韩国栋'],
    director: '孟书言',
    episodes: 32,
    updateTime: '2024-12-01',
    synopsis:
      '三个来自小城的年轻人在大都市打拼，经历创业失败、情感波折与家庭压力，最终在城市的晨光里找到属于自己的方向。一部关于坚持与和解的现实主义都市群像剧。',
    tags: ['现实题材', '都市群像', '温暖励志'],
    rating: 8.4,
    heat: 7460,
  },
  {
    id: 'tv-003',
    title: '深巷暖阳',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20family%20drama%20poster%20of%20an%20old%20Chinese%20alley%20with%20golden%20afternoon%20sunlight%2C%20red%20lanterns%20and%20cozy%20doorways%2C%20soft%20nostalgic%20atmosphere%2C%20minimal%20background%2C%20cinematic%20photography%2C%20warm%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-003&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['家庭', '年代', '剧情'],
    actors: ['赵淑芬', '刘长贵', '孙小满', '郑浩然'],
    director: '何晓松',
    episodes: 40,
    updateTime: '2023-11-20',
    synopsis:
      '上世纪八十年代，一条老巷子里的几户人家，在时代变迁中相互扶持、悲欢与共。烟火气十足的日常背后，是普通人对生活的坚守，也是一代人的集体记忆。',
    tags: ['年代质感', '烟火人间', '家庭温情'],
    rating: 9.1,
    heat: 8130,
  },
  {
    id: 'tv-004',
    title: '医者仁心',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Medical%20drama%20poster%20of%20a%20doctor%20in%20white%20coat%20standing%20in%20a%20hospital%20corridor%2C%20soft%20cool%20light%20with%20warm%20red%20accent%20line%2C%20clean%20minimal%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-004&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['医疗', '职场', '剧情'],
    actors: ['方致远', '沈壁君', '杜院长'],
    director: '柯云川',
    episodes: 38,
    updateTime: '2024-09-15',
    synopsis:
      '急诊科医生方致远在一次次与死神赛跑的抢救中，直面医疗体制的现实困境与人性的抉择。他与年轻住院医师沈壁君并肩作战，诠释了医者最朴素的仁心。',
    tags: ['医疗职场', '生命议题', '群像叙事'],
    rating: 8.7,
    heat: 7920,
  },
  {
    id: 'tv-005',
    title: '岁月长歌',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20period%20drama%20poster%20with%20elegant%20traditional%20architecture%20and%20drifting%20mist%2C%20warm%20red%20and%20gold%20accents%2C%20minimal%20atmospheric%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-005&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['年代', '历史', '剧情'],
    actors: ['顾长风', '叶知秋', '林牧之'],
    director: '王朝宗',
    episodes: 46,
    updateTime: '2023-08-08',
    synopsis:
      '跨越三十年的家族史，讲述一个普通家庭在时代洪流中的起伏与坚守。三代人的命运交织成一曲关于家国、理想与牺牲的长歌。',
    tags: ['年代史诗', '家国情怀', '群像巨制'],
    rating: 8.8,
    heat: 6880,
  },
  {
    id: 'tv-006',
    title: '山海之约',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20poster%20of%20a%20coastal%20mountain%20landscape%20at%20dusk%20with%20two%20distant%20figures%2C%20warm%20deep%20red%20sunset%20glow%2C%20soft%20mist%2C%20minimal%20background%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-006&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['爱情', '剧情', '都市'],
    actors: ['温以宁', '江风眠', '夏若雪'],
    director: '沈从之',
    episodes: 34,
    updateTime: '2025-09-30',
    synopsis:
      '因一场意外结缘的两个人，约定在十年后的山海间重逢。时光辗转，各自成长，那段未曾说出口的誓言，能否跨越山海如约而至。',
    tags: ['都市爱情', '久别重逢', '治愈系'],
    rating: 8.3,
    heat: 8540,
  },
  {
    id: 'tv-007',
    title: '暗夜追凶',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Suspense%20crime%20drama%20poster%20of%20a%20rainy%20neon%20city%20street%20at%20night%20with%20a%20detective%20silhouette%2C%20moody%20dark%20tones%20with%20deep%20red%20accent%2C%20minimal%20atmospheric%20background%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-007&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '犯罪', '刑侦'],
    actors: ['高寒川', '林见鹿', '马国栋'],
    director: '唐奕辰',
    episodes: 24,
    updateTime: '2024-10-18',
    synopsis:
      '一桩沉寂十年的悬案重新浮出水面，刑警高寒川与法医林见鹿联手追查，层层反转之下，真相远比想象中残酷。一场关于正义与执念的暗夜较量。',
    tags: ['刑侦悬疑', '高能反转', '烧脑推理'],
    rating: 8.6,
    heat: 9010,
  },
  {
    id: 'tv-008',
    title: '一念之间',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Psychological%20drama%20poster%20of%20a%20split%20face%20reflection%20in%20glass%2C%20abstract%20warm%20red%20and%20cool%20gray%20tones%2C%20minimal%20conceptual%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-008&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['悬疑', '剧情', '心理'],
    actors: ['聂子谦', '白露', '许嘉言'],
    director: '严牧',
    episodes: 20,
    updateTime: '2025-07-21',
    synopsis:
      '一名心理咨询师接连遇到几位看似无关的来访者，却逐渐发现他们的命运都指向同一件事。善恶往往只在一念之间，而每个选择都将改变一切。',
    tags: ['心理悬疑', '人性探讨', '多线叙事'],
    rating: 8.5,
    heat: 7320,
  },
  {
    id: 'tv-009',
    title: '青春备忘录',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Youth%20campus%20drama%20poster%20of%20high%20school%20students%20in%20warm%20sunlight%2C%20notebooks%20and%20bicycles%2C%20soft%20nostalgic%20warm%20tones%2C%20minimal%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-009&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['青春', '校园', '成长'],
    actors: ['叶星辰', '苏浅浅', '周叙白'],
    director: '许多多',
    episodes: 28,
    updateTime: '2024-06-30',
    synopsis:
      '高三那年，一群少年在升学压力与懵懂情感中跌跌撞撞地长大。多年后翻开这本青春备忘录，才发现那些平凡的日常，原来是最好的时光。',
    tags: ['青春校园', '成长治愈', '怀旧滤镜'],
    rating: 8.2,
    heat: 6640,
  },
  {
    id: 'tv-010',
    title: '锦衣少年行',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20poster%20with%20a%20young%20warrior%20in%20elegant%20robe%20holding%20a%20blade%2C%20warm%20golden%20light%20and%20red%20silk%2C%20minimal%20atmospheric%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-010&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['古装', '武侠', '剧情'],
    actors: ['裴知遥', '柳青鸾', '段无情'],
    director: '风清越',
    episodes: 42,
    updateTime: '2025-08-14',
    synopsis:
      '出身寒微的少年因一桩冤案卷入朝堂纷争，在江湖与庙堂之间步步为营。刀光剑影里，他寻找的不仅是真相，更是一份未曾动摇的侠义初心。',
    tags: ['古装武侠', '少年热血', '权谋江湖'],
    rating: 8.4,
    heat: 8760,
  },
  {
    id: 'tv-011',
    title: '我们的小食光',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20food%20drama%20poster%20of%20a%20warm%20small%20restaurant%20kitchen%20with%20steaming%20dishes%2C%20deep%20red%20and%20amber%20tones%2C%20soft%20inviting%20light%2C%20minimal%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-011&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['都市', '治愈', '喜剧'],
    actors: ['何小满', '程岳', '老陶'],
    director: '蔡文君',
    episodes: 30,
    updateTime: '2023-05-12',
    synopsis:
      '一家藏在老街区的小餐馆，接待着形形色色的客人。一道道家常菜背后，是每个平凡人的喜怒哀乐。用食物治愈人心，是这家店最温柔的坚持。',
    tags: ['美食治愈', '人间烟火', '群像故事'],
    rating: 8.6,
    heat: 6120,
  },
  {
    id: 'tv-012',
    title: '破冰行动队',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Action%20crime%20series%20poster%20of%20a%20police%20task%20force%20team%20silhouette%20against%20cold%20blue%20dawn%20with%20red%20accent%2C%20dramatic%20atmosphere%2C%20minimal%20background%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-012&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['犯罪', '动作', '刑侦'],
    actors: ['雷正霆', '岳青峰', '江雪'],
    director: '司徒朗',
    episodes: 26,
    updateTime: '2024-11-05',
    synopsis:
      '一支临时组建的特别行动队，深入边境追查跨国犯罪集团。危险与背叛并存的绝境中，他们用生命践行着那句"绝不后退"。',
    tags: ['硬核动作', '缉毒题材', '热血群像'],
    rating: 8.5,
    heat: 8280,
  },
  {
    id: 'tv-013',
    title: '星辰大海',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Science%20fiction%20drama%20poster%20of%20astronauts%20looking%20at%20distant%20galaxy%2C%20deep%20cosmic%20tones%20with%20warm%20red%20nebula%20accent%2C%20minimal%20atmospheric%20background%2C%20cinematic%20editorial%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-013&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['科幻', '剧情', '太空'],
    actors: ['周星野', '林海音', '高远'],
    director: '聂远征',
    episodes: 24,
    updateTime: '2025-06-18',
    synopsis:
      '中国深空探测团队为完成一次前所未有的星际任务，跨越十年筹备与无数次失败。仰望星空的人，终将把梦想写进浩瀚的星辰大海。',
    tags: ['硬核科幻', '航天题材', '宏大叙事'],
    rating: 8.7,
    heat: 7640,
  },
  {
    id: 'tv-014',
    title: '家有小欢喜',
    type: 'tv',
    cover: 'https://readdy.ai/api/search-image?query=Lighthearted%20family%20comedy%20poster%20of%20a%20cheerful%20modern%20Chinese%20household%2C%20warm%20bright%20interior%20with%20red%20accents%2C%20cozy%20inviting%20light%2C%20minimal%20background%2C%20editorial%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-tv-014&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['家庭', '喜剧', '都市'],
    actors: ['方圆圆', '马建军', '李婶'],
    director: '苏禾',
    episodes: 34,
    updateTime: '2024-04-22',
    synopsis:
      '一个三代同堂的普通家庭，围绕着孩子升学、老人养老、夫妻相处上演着一出出啼笑皆非的日常。鸡毛蒜皮里，藏着最真实的小欢喜。',
    tags: ['家庭喜剧', '轻松治愈', '都市生活'],
    rating: 8.1,
    heat: 5980,
  },
  {
    id: 'mv-001',
    title: '长夜将尽',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20lone%20figure%20walking%20toward%20cold%20blue%20dawn%20horizon%2C%20warm%20red%20rim%20light%2C%20dramatic%20minimal%20composition%2C%20editorial%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-001&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '悬疑'],
    actors: ['秦越', '叶楠', '周沉'],
    director: '顾长夜',
    episodes: 1,
    updateTime: '2025-10-01',
    synopsis:
      '一名即将退休的老警察，在最后一个案件里遇见了与自己纠缠半生的真相。长夜将尽，天快亮了，可有些人再也等不到黎明。',
    tags: ['悬疑剧情', '人性叩问', '影像质感'],
    rating: 8.8,
    heat: 7120,
  },
  {
    id: 'mv-002',
    title: '归途',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Emotional%20road%20film%20poster%20of%20a%20countryside%20highway%20at%20golden%20hour%20with%20a%20traveling%20car%2C%20warm%20amber%20and%20red%20tones%2C%20vast%20minimal%20landscape%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20composition&width=400&height=600&seq=drama-mv-002&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '公路', '家庭'],
    actors: ['何建国', '刘晓芸', '小石头'],
    director: '张远行',
    episodes: 1,
    updateTime: '2024-11-28',
    synopsis:
      '一对渐行渐远的父子，为了送母亲的骨灰返乡，踏上了一场横跨千里的旅程。一路上的争吵与沉默，最终都化作了迟来的理解。',
    tags: ['公路电影', '家庭和解', '催泪温情'],
    rating: 8.9,
    heat: 6980,
  },
  {
    id: 'mv-003',
    title: '无声的告白',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20poster%20of%20two%20silhouettes%20facing%20each%20other%20in%20soft%20backlight%2C%20warm%20deep%20red%20and%20cream%20tones%2C%20minimal%20emotional%20composition%2C%20editorial%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-003&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['爱情', '剧情'],
    actors: ['苏晚', '陆遥', '沈嘉树'],
    director: '林微光',
    episodes: 1,
    updateTime: '2025-08-20',
    synopsis:
      '听障女孩苏晚与落魄作曲家陆遥在无声与有声的世界里相遇。有些爱，不必说出口，也能被听见。一段关于理解与陪伴的温柔告白。',
    tags: ['爱情文艺', '细腻治愈', '情感佳作'],
    rating: 8.6,
    heat: 6540,
  },
  {
    id: 'mv-004',
    title: '云端之梦',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Inspirational%20film%20poster%20of%20a%20small%20airplane%20soaring%20above%20sea%20of%20clouds%20at%20sunrise%2C%20warm%20red%20and%20gold%20sky%2C%20minimal%20uplifting%20composition%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-004&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['励志', '剧情', '运动'],
    actors: ['高飞', '许晴川', '雷教练'],
    director: '吴凌云',
    episodes: 1,
    updateTime: '2023-09-10',
    synopsis:
      '出身山村的高飞一心想成为飞行员，面对质疑与失败却从未放弃。当梦想终于冲破云层，他看见的不只是天空，还有一路咬牙坚持的自己。',
    tags: ['励志成长', '追梦题材', '热血感动'],
    rating: 8.4,
    heat: 6320,
  },
  {
    id: 'mv-005',
    title: '城市之光',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Urban%20drama%20poster%20of%20a%20night%20cityscape%20with%20thousands%20of%20warm%20lights%20and%20deep%20red%20highlights%2C%20reflective%20wet%20streets%2C%20minimal%20atmospheric%20composition%2C%20cinematic%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-005&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '都市', '群像'],
    actors: ['程亮', '苏梦', '老周'],
    director: '陆屿川',
    episodes: 1,
    updateTime: '2024-12-19',
    synopsis:
      '同一座城市的五个夜晚，五个陌生人因一场意外产生了交集。在钢筋水泥的森林里，每个渺小的人都是自己生命里的那束光。',
    tags: ['都市群像', '多线交错', '现实关照'],
    rating: 8.5,
    heat: 6240,
  },
  {
    id: 'mv-006',
    title: '风雪夜归人',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Winter%20drama%20film%20poster%20of%20a%20snowy%20night%20village%20with%20a%20lone%20lantern%20glow%2C%20cold%20blue%20and%20warm%20red%20contrast%2C%20minimal%20atmospheric%20composition%2C%20cinematic%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-006&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '文艺', '悬疑'],
    actors: ['韩山', '白清秋', '鲁大海'],
    director: '费敬之',
    episodes: 1,
    updateTime: '2023-12-24',
    synopsis:
      '一个风雪交加的除夕夜，一间客栈，几位素不相识的客人。当真相随着炉火逐渐浮现，每个人都无法再假装自己只是过路人。',
    tags: ['文艺悬疑', '群像密室', '氛围极佳'],
    rating: 8.7,
    heat: 5820,
  },
  {
    id: 'mv-007',
    title: '时间的朋友',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Time%20travel%20romance%20poster%20of%20a%20vintage%20clock%20dissolving%20into%20warm%20light%2C%20deep%20red%20and%20amber%20tones%2C%20abstract%20minimal%20composition%2C%20editorial%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-007&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['爱情', '奇幻', '剧情'],
    actors: ['顾时安', '林晚', '周先生'],
    director: '何以琛',
    episodes: 1,
    updateTime: '2025-09-05',
    synopsis:
      '一间旧钟表店让他拥有了回到过去的可能。为了弥补遗憾，他一次次改写时间，却发现真正需要被原谅的，是那个一直不肯放下执念的自己。',
    tags: ['奇幻爱情', '时间叙事', '治愈系'],
    rating: 8.6,
    heat: 6740,
  },
  {
    id: 'mv-008',
    title: '海岸线',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Seaside%20drama%20film%20poster%20of%20a%20long%20coastline%20at%20sunset%20with%20gentle%20waves%20and%20a%20distant%20lighthouse%2C%20warm%20red%20and%20blue%20tones%2C%20minimal%20serene%20composition%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-008&orientation=portrait',
    year: 2024,
    region: '中国香港',
    genres: ['剧情', '家庭', '文艺'],
    actors: ['梁启文', '郑小柔', '阿海'],
    director: '陈嘉行',
    episodes: 1,
    updateTime: '2024-07-14',
    synopsis:
      '退休渔民梁启文守着一片即将被开发的海湾，与多年不归的女儿之间隔着一道难以跨越的海。潮起潮落间，父女俩终于学会彼此靠近。',
    tags: ['文艺亲情', '慢节奏', '回不去的故乡'],
    rating: 8.5,
    heat: 5210,
  },
  {
    id: 'mv-009',
    title: '逆光而行',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Inspirational%20thriller%20poster%20of%20a%20determined%20figure%20walking%20against%20blinding%20backlight%2C%20warm%20red%20and%20deep%20shadow%20contrast%2C%20minimal%20dramatic%20composition%2C%20cinematic%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-009&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '励志', '运动'],
    actors: ['聂川', '方晴', '老孟'],
    director: '雷牧阳',
    episodes: 1,
    updateTime: '2025-05-30',
    synopsis:
      '因伤退役的长跑运动员聂川，为了兑现对教练的承诺，重新站上赛道。逆着光奔跑的他，要用最后一程证明，放弃从来不是唯一的选择。',
    tags: ['热血励志', '体育题材', '燃向'],
    rating: 8.3,
    heat: 5980,
  },
  {
    id: 'mv-010',
    title: '尘埃里开花',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Heartwarming%20film%20poster%20of%20a%20blooming%20flower%20rising%20from%20dry%20earth%2C%20warm%20red%20and%20golden%20light%2C%20minimal%20conceptual%20composition%2C%20editorial%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-010&orientation=portrait',
    year: 2023,
    region: '中国大陆',
    genres: ['剧情', '女性', '励志'],
    actors: ['何秀莲', '小静', '张老师'],
    director: '文秀兰',
    episodes: 1,
    updateTime: '2023-03-08',
    synopsis:
      '一位乡村女教师用二十年的坚守，把一批批山里娃送出了大山。她没有惊天动地的壮举，却让希望在贫瘠的土地上，悄然开出了花。',
    tags: ['女性力量', '现实主义', '催泪佳作'],
    rating: 8.9,
    heat: 5460,
  },
  {
    id: 'mv-011',
    title: '我们俩',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Intimate%20two-hander%20drama%20poster%20of%20an%20elderly%20woman%20and%20a%20young%20woman%20sharing%20tea%20in%20a%20small%20courtyard%2C%20warm%20red%20and%20cream%20tones%2C%20minimal%20heartfelt%20composition%2C%20cinematic%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-011&orientation=portrait',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '女性', '文艺'],
    actors: ['马奶奶', '林小满'],
    director: '苏念真',
    episodes: 1,
    updateTime: '2024-10-08',
    synopsis:
      '独居老人与上门租房的女大学生，从彼此戒备到相依为命。一间老屋，两个年龄悬殊的女人，在漫长四季里慢慢成为彼此唯一的家人。',
    tags: ['女性情谊', '慢生活', '细腻动人'],
    rating: 8.8,
    heat: 5680,
  },
  {
    id: 'mv-012',
    title: '最后一班地铁',
    type: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Night%20urban%20romance%20poster%20of%20an%20empty%20subway%20platform%20with%20warm%20red%20station%20lights%2C%20reflective%20floor%20and%20gentle%20mood%2C%20minimal%20atmospheric%20composition%2C%20cinematic%20movie%20photography%2C%20high%20detail%2C%20harmonious%20tones&width=400&height=600&seq=drama-mv-012&orientation=portrait',
    year: 2025,
    region: '中国大陆',
    genres: ['爱情', '剧情', '都市'],
    actors: ['周未眠', '苏星禾'],
    director: '江照',
    episodes: 1,
    updateTime: '2025-04-16',
    synopsis:
      '每天夜里，他们都会在末班地铁上相遇，却从未说过一句话。直到某天，其中一个人再没有出现，另一个人才意识到那份沉默早已成了牵挂。',
    tags: ['都市爱情', '错过的温柔', '氛围叙事'],
    rating: 8.4,
    heat: 6120,
  },
];